module.exports = __webpack_public_path__ + "media/images/logo_w-a3136aab1394fecab1e16e049200ec68.png";